import axios from 'axios';
import { applyApiBaseUrl, retryWithDirectApi, shouldFallbackFromProxy, type ApiAxiosConfig } from './api-fallback';

/**
 * Separate Axios instance for admin API calls.
 * Uses its own token stored under 'admin_token' in localStorage.
 */
export const adminHttp = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
});

adminHttp.interceptors.request.use(
  (config) => {
    applyApiBaseUrl(config as ApiAxiosConfig);
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      if (typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
      } else {
        delete config.headers['Content-Type'];
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminHttp.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config as ApiAxiosConfig | undefined;
    if (config && shouldFallbackFromProxy(error)) {
      return retryWithDirectApi(config, (cfg) => adminHttp.request(cfg));
    }

    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith('/admin') && path !== '/admin/adminLogin' && error.response) {
        localStorage.removeItem('admin_token');
        window.location.href = '/admin/adminLogin';
      }
    }
    return Promise.reject(error);
  }
);

export default adminHttp;
